import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IComparisonCenter } from "./interfaces";
import { DataGridPanel, ListPageHeader } from "components/list";
import { compareCentersColumns } from "./components/compareCentersColumns";

export const ComparisonCenterList: React.FC = () => {

    const { dataGridProps, tableQueryResult } = useDataGrid<IComparisonCenter>({
        initialCurrent: 1,
        initialPageSize: 20,
        filters: {
            mode: "server", // client에서 필터링을 처리함.
        },
        // queryOptions: {
        //     select(data) {
        //         return { ...data, mode: modes }; // 동적으로 mode 값을 할당합니다.
        //     },
        // }
    });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    // 로딩이 아닐 때의 마지막 값을 유지해 표시한다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="외부 데이터와 비교 대상인 시설 목록"
            />

            <DataGridPanel
                {...dataGridProps}
                columns={compareCentersColumns}
                isError={tableQueryResult.isError}
                errorMessage="비교 시설 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 비교 시설이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
            />
        </List>
    );
};
